import { Link, useNavigate } from "react-router-dom";
import { getUserRole } from "../security/roleManager";
import { ROLES } from "../security/roles";

export default function Navbar() {

  const role = getUserRole();
const navigate = useNavigate();

const handleLogout = () => {
  localStorage.removeItem("FENTASAFE_DEMO_TOKEN");
  localStorage.removeItem("FENTASAFE_TOKEN");
  localStorage.removeItem("FENTASAFE_ROLE");
  localStorage.removeItem("FENTASAFE_USER");

  sessionStorage.clear();

  window.location.replace("/demo");
};

  return (
    <nav style={styles.nav}>
      <div style={styles.logo}>FentaSafe</div>

      <div style={styles.links}>
        <Link to="/" style={styles.link}>Home</Link>

        <Link to="/live" style={{ ...styles.link, ...styles.liveLink }}>
          Live
        </Link>

        <Link to="/demo" style={styles.link}>Demo</Link>

        <Link to="/use-cases" style={{ ...styles.link, ...styles.useCaseLink }}>
          Use Cases
        </Link>

        <Link to="/public-safety" style={styles.link}>
          Public Safety
        </Link>

        <Link to="/technology" style={styles.link}>Technology</Link>
   <Link
  to="/ai-command-center"
  style={{
    ...styles.link,
    color:"#f59e0b",
    fontWeight:600
  }}
>
  Agentic AI Command Center
</Link>

        <Link to="/about" style={styles.link}>About</Link>
        <Link to="/contact" style={styles.link}>Contact</Link>
        {(
  role === ROLES.DEMO_USER ||
  role === ROLES.CUSTOMER_ADMIN ||
  role === ROLES.FENTASAFE_ADMIN
) && (
  <button
    onClick={handleLogout}
    style={styles.logoutButton}
  >
    Logout
  </button>
)}
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    position: "sticky",   // 🔥 FIXED
    top: 0,
    background: "#020617",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    zIndex: 2000,
    borderBottom: "1px solid #1e293b",
  },

  logo: {
    fontWeight: 700,
    fontSize: "1.25rem",
    whiteSpace: "nowrap",
  },

  links: {
    display: "flex",
    alignItems: "center",
    gap: 24,
  },

  link: {
    color: "#e5e7eb",
    textDecoration: "none",
    fontWeight: 500,
    fontSize: "0.95rem",
  },

  liveLink: {
    color: "#22c55e",
    fontWeight: 600,
  },

  useCaseLink: {
    color: "#38bdf8",
    fontWeight: 600,
  },
logoutButton: {
  background: "#dc2626",
  color: "white",
  border: "none",
  borderRadius: "6px",
  padding: "8px 12px",
  cursor: "pointer",
  fontWeight: 600,
  marginLeft: "12px"
},
};